import {
  CoolblueLogo,
  Header,
  HeaderLogoContainer,
  LogoLink
} from '@coolblue-development/next-header/client';

export default function SimpleHeader() {
  return (
    <Header>
      <LogoLink link='/'>
        <HeaderLogoContainer>
          <CoolblueLogo />
        </HeaderLogoContainer>
      </LogoLink>
    </Header>
  );
}
